<ion-header mode="md">
  <!-- UWAGA! Nie kasuj poniższego tagi ion-toolbar. Jest niezbędny do prawidłowego wyświetlania aplikacji na telefonach z notchem -->
  <!-- <ion-toolbar class="ion-item"></ion-toolbar> -->
  <ion-item
    class="header__desktop-container"
    lines="none"
    [ngClass]="{
      'overflow-hidden': headerInit.showRightButtonsOnlyOnMobile
        ? p.renderMobile
        : false
    }"
  >
    <ion-buttons slot="start" class="header__buttons-container">
      <!-- DIV powodował błąd nawigacji dla wersji desktopowej, nakładał maskę na początku sekcji menu i powodował, że wybór pierwszej opcji z menu miało działanie przycisku wstecz, który cofał nas do poprzedniej wybranej opcji. -->
      <!-- Natomiast w wersji mobilnej nakład maskę na przycisk powrotu do strony głównej i również tylko wtedy przycisk cofał nas do poprzedniej wybranej przez nas opcji -->
      <!-- Pozostawiony w komentarzu zamiast zamiast usuwać, gdyby była potrzeba przywrócenia tego diva do kodu -->
      <!-- <div
        class="header__back-button-mask"
        (click)="hideSubheader($event)"
      ></div> -->
      <ion-back-button
        class="header__back-button show-back-button"
        *ngIf="p.renderMobile && internetServ.isOnline"
        text=""
        [defaultHref]="headerInit.backDefaultHref"
      >
      </ion-back-button>
      <ion-item
        *ngIf="
          headerInit.segments &&
          headerInit.segments?.length > 0 &&
          !p.renderMobile
        "
        mode="md"
        lines="none"
        class="ion-no-padding"
      >
        <ion-segment
          [value]="activeSegment"
          (ionChange)="
            headerInit.segmentsChangeFunc($event); setActiveSegment($event)
          "
          scrollable
        >
          <ion-segment-button
            [ngClass]="{ 'w-0': item.name?.length == 0 }"
            *ngFor="let item of headerInit.segments"
            [value]="item.value"
          >
            <ion-label> {{ item.name | translate }}</ion-label>
            <ion-badge
              *ngIf="item?.badge && item?.badge > 0"
              color="danger"
              class="badge-counter badge-counter--desktop"
            >{{ item?.badge }}</ion-badge>
          </ion-segment-button>
        </ion-segment>
      </ion-item>
    </ion-buttons>
    <ion-title *ngIf="p.renderMobile && headerInit.title">
      <ion-item lines="none" class="header__title">
        <ion-label class="header__title-label">
          {{ headerInit.title | translate }}
        </ion-label>
      </ion-item>
    </ion-title>
    <ng-container
      *ngIf="headerInit.showRightButtonsOnlyOnMobile ? p.renderMobile : true"
    >
      <ion-buttons
        slot="end"
        *ngIf="headerInit.rightButtons?.length > 0"
        class="ion-no-margin margin-right-4"
      >
        <ng-container *ngFor="let item of headerInit.rightButtons">
          <ion-button
            *ngIf="item.permission"
            (click)="item.onClick()"
            [fill]="
              item.fill ? item.fill : p.renderMobile ? 'clear' : 'outline'
            "
            [class]="item.class"
            shape="round"
          >
            <ion-icon
              [slot]="item.name ? 'start' : 'icon-only'"
              *ngIf="item.iconName"
              [name]="item.iconName"
              [class]="item.class"
            ></ion-icon>
            <ion-icon
              [slot]="item.name ? 'start' : 'icon-only'"
              *ngIf="item.iconUrl"
              [src]="item.iconUrl"
              [class]="item.class"
            ></ion-icon>

            <ng-container
              *ngIf="
                headerInit.hideRightButtonsTextOnMobile ? !p.renderMobile : true
              "
            >
              <ion-text *ngIf="item.name">
                {{ item.name | translate }}
              </ion-text>
            </ng-container>
            <ion-text *ngIf="item.counter" class="counter">{{
              item.counter | async
            }}</ion-text>
          </ion-button>
        </ng-container>
      </ion-buttons>
    </ng-container>
    <ion-buttons
      slot="end"
      class="ion-no-margin margin-right-16"
      *ngIf="headerInit.showRightButtonsOnlyOnMobile ? !p.renderMobile : true"
    >
      <app-user-settings
        [mobileViewBreakPoint]="
          headerInit.userSettingsBreakpoint
            ? headerInit.userSettingsBreakpoint
            : defaultBreakpoint
        "
      ></app-user-settings>
    </ion-buttons>
  </ion-item>
</ion-header>
<ng-container *ngIf="p.renderMobile">
  <span [ngClass]="subheaderHidden ? 'ion-hide' : ''">
    <ion-item
      mode="md"
      *ngIf="headerInit.segments && headerInit.segments?.length > 0"
      lines="none"
      [ngClass]="
        headerInit.mobileSegments?.length || headerInit.shouldHasMobileSegments
          ? 'main-segment ion-no-padding'
          : 'main-segment-like-secondary'
      "
    >
      <ion-segment
        [value]="activeSegment"
        (ionChange)="
          headerInit.segmentsChangeFunc($event); setActiveSegment($event)
        "
        scrollable
      >
        <ion-segment-button
          *ngFor="let item of headerInit.segments; let i = index"
          [id]="item.value"
          (click)="scrollTo($event)"
          [value]="item.value"
          [ngClass]="{ 'w-0': item.name?.length == 0 }"
        >
          <ion-label> {{ item.name | translate }}</ion-label>
          <ion-badge
            *ngIf="item?.badge && item?.badge > 0"
            color="danger"
            class="badge-counter badge-counter--mobile"
          >{{ item?.badge }}</ion-badge>
        </ion-segment-button>
      </ion-segment>
    </ion-item>
  </span>
</ng-container>

<ng-container *ngIf="showMobileSegments()">
  <ion-item
    mode="md"
    *ngIf="headerInit.mobileSegments && headerInit.mobileSegments?.length > 0"
    lines="none"
    class="ion-no-padding border-top"
    [ngClass]="subheaderHidden ? 'ion-hide' : ''"
  >
    <ion-segment
      [value]="headerInit.mobileSegments[0]?.value"
      (ionChange)="headerInit.mobileSegmentsChangeFunc($event)"
      scrollable
      class="secondary-segment"
    >
      <ion-segment-button
        *ngFor="let mobileItem of headerInit.mobileSegments"
        [value]="mobileItem.value"
        class="secondary-segment-button"
        (click)="scrollTo($event)"
      >
        <ion-label *ngIf="!mobileItem.translated">
          {{ mobileItem.name | translate }}</ion-label
        >
        <ion-label *ngIf="mobileItem.translated">
          {{ mobileItem.name }}</ion-label
        >
      </ion-segment-button>
    </ion-segment>
  </ion-item>
</ng-container>
